<div class="form-control-radio">
  <label>{{placeholder}}</label>
  <!-- <div class="form-control-radio-pane"></div> -->
  <input style="right: -30px;opacity: 2;" type="radio" id="{{ID}}" class="form-control-radio" name="{{name}}"
   [value]="value" [checked]="model === value" (change)="updateValue($event.target.value)"/>
</div>

